/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);


// BBX update mixed pre-order note after cart contents change
document.addEventListener('on:cart:after-merge', async function() {
  try {
    const response = await fetch(window.location.pathname);
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const freshNote = doc.querySelector('[data-bbx-preorder-note]');
    const currentNote = document.querySelector('[data-bbx-preorder-note]');

    // Mixed cart has just been created → add the note
    if (freshNote && !currentNote) {
      const checkoutButtons = document.querySelector(
        'cart-drawer .checkout-buttons'
      );

      if (checkoutButtons) {
        checkoutButtons.insertAdjacentHTML(
          'beforebegin',
          freshNote.outerHTML
        );
      }
    }

    // Cart is still mixed → refresh the note markup if needed
    if (freshNote && currentNote) {
      currentNote.replaceWith(freshNote);
    }

    // Cart is no longer mixed → remove the note
    if (!freshNote && currentNote) {
      currentNote.remove();
    }

  } catch (error) {
    console.error('BBX preorder note update error:', error);
  }
});